import { logger } from '@/lib/utils/logger';
import type { DirectiveSubscribeFn, ServerDirective } from './types';

/**
 * Combines multiple directive emitters into a single subscribe function.
 * Phase 2 uses this to fan a single DirectiveHandler subscription out
 * across `userSession.onDirective`, `adminSession.onDirective`,
 * `userApiClient.onDirective`, `adminApiClient.onDirective`.
 *
 * Returns a single unsubscribe that detaches from every upstream source.
 */
export function mergeDirectiveSources(
  ...sources: DirectiveSubscribeFn[]
): DirectiveSubscribeFn {
  return (callback: (d: ServerDirective) => void): (() => void) => {
    const unsubs = sources.map((src) => src(callback));
    return () => {
      for (const u of unsubs) {
        try {
          u();
        } catch (err) {
          // Best-effort cleanup; one bad unsubscribe must not block the rest.
          logger.warn('mergeDirectiveSources: source unsubscribe failed', { err });
        }
      }
    };
  };
}
